import React, { useState } from 'react'

const Home = () => {
    const [show,setShow] =useState(true)
  return (
    <>
      <div scrolling="no" className='mainHome'>
          <div className='copydiv' onClick={()=>setShow(false)}>
          {
              show ? <><h2>Modified by shaon</h2>
              <img src="https://i.ibb.co/Mk4czcr/Opera-Snapshot-2022-04-28-232240-framesynthesis-com.png" alt="sdsd" /> </>: <p></p>
          }
          </div>
      <iframe
        width="100%"
        height="100%"
        src="https://korinvr.com/bin/drivingsimulatorgm/25/"
        frameBorder="0"
        scrolling="no"
        title="googlemap"
      ></iframe>
    </div>
    </>
  )
}

export default Home
